import { useCallback } from 'react';
import { useTranslate } from '../../translations';
import { useAdvert } from './hooks/useAdvert';
import { getCurrentAdvertId } from './utils/getCurrentAdvertId';
import { Alert } from '../../components/alert';
import { useApplyMutation } from './hooks/useApplyMutation';
import { SuccessAlert } from '../../components/success-alert';
import { ApplicationFormValues } from './model';
import { DynamicForm } from '../dynamic-form';
import styles from './Application.module.scss';

export const Application = () => {
  const translator = useTranslate();
  const { fields, initialValues, submit, isValid, schema, advert } = useAdvert(getCurrentAdvertId());
  const {
    mutate: sendApply,
    isLoading,
    isSuccess: isSubmitSuccess,
    isError: isSubmitError,
    data: submitResponse,
  } = useApplyMutation(getCurrentAdvertId());

  const onSubmit = useCallback(
    (data: ApplicationFormValues) => {
      sendApply(data);
    },
    [sendApply],
  );

  if (!isValid) {
    return <Alert color="warning">{translator('form_missing')}</Alert>;
  }

  if (isSubmitSuccess) {
    return <SuccessAlert title={translator('success_title')} employeeUrl={submitResponse.employeeUrl} />;
  }

  return (
    <>
      {!!advert.message && (
        <Alert color="primary" className={styles.message}>
          <div dangerouslySetInnerHTML={{ __html: advert.message }} />
        </Alert>
      )}
      <h2 className="fs-4 fw-bold mb-3 text-primary">{translator('application')}</h2>
      <DynamicForm
        fields={fields}
        onSubmit={onSubmit}
        initialValues={initialValues}
        schema={schema}
        submitLabel={submit?.label}
        isLoading={isLoading}
        error={isSubmitError ? translator('submit_error') : undefined}
      />
    </>
  );
};
